import React, { Component } from "react"
import { Row } from "antd"
import { Link } from "react-router-dom"
import UploadModal from "app/components/normal/BasicModal/UploadModal"
import WelcomeContainer from "app/components/common/WelcomeContainer"
import dashButton from "app/styles/images/sp/dashboard.svg"
import uploadButton from "app/styles/images/sp/pgd-upload.svg"
import { observable, action } from "mobx"
import { observer, inject } from "mobx-react"
import { getCurrentApp } from "app/api/localTools"
import "app/pages/login/Index.scss"
import "./Index.scss"
import styled from "styled-components"

@inject("entrance", 'auth')@observer
export default class Index extends Component {
  @observable uploadModalOpened = false
  @observable sectionInfo = {}

  @action toggleModal = (info = {}) => {
    this.uploadModalOpened = !this.uploadModalOpened
    this.sectionInfo = info
  }

  componentDidMount() {
    const { auth } = this.props
    auth.getPushAuth()
    auth.needLoadApps && auth.getApps()
    this.props.entrance.loadSectionList()
  }

  render() {
    const { entrance: { sectionList }, auth: { pushAuth } } = this.props
    const sectionCount = sectionList.length
    const sectionHeight = 210 / sectionCount
    const sectionMarB = 20 / sectionCount
    const Section = styled.p`
      cursor: pointer;
      background: #286cac;
      border-radius: 4px;
      padding: 0;
      margin-bottom: ${sectionMarB}px;
      width: 235px;
      height: ${sectionHeight}px;
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      line-height: ${sectionHeight}px;
      margin-left: 24px;
      color: #ffffff;
      text-align: center;
    `
    return (
      <WelcomeContainer>
        <Row className="entrance-container">
          {getCurrentApp() === "pgd"
           ? <div className="entrance-wrapper">
               <h3><i className="dna-icon" />快速上传通道<i className="dna-icon" /></h3>
               <div
                 onClick={() => this.toggleModal(sectionList[0])}
                 className="cursor-p entrance-web pgd"
                >
                 <img alt="" src={uploadButton}/>
                 <div className="entrance-text">PGD数据上传</div>
               </div>
               <div className="shadow-way"> </div>
             </div>
           : <div className="entrance-wrapper">
               <h3><i className="dna-icon" />快速上传通道<i className="dna-icon" /></h3>
               {sectionList.map(item =>
                 <Section
                   onClick={() => this.toggleModal(item)}
                   key={item.id}>
                   {item.name}
                 </Section>
                 )
               }
               <div className="shadow-way"></div>
             </div>
          }
          <div className="entrance-wrapper">
            <h3><i className="dna-icon" />控制台入口<i className="dna-icon" /></h3>
            <Link className="entrance-web" to={`/public/main/${getCurrentApp()}/dashboard`}>
              <img alt="" src={dashButton}/>
              <div className="entrance-text">点击进入控制台</div>
            </Link>
            <div className="shadow-dash"> </div>
          </div>
        </Row>
        {this.uploadModalOpened &&
          <UploadModal
            visible={true}
            verifyLimsPgdFamily={pushAuth.verifyLimsPgdFamily}
            info={this.sectionInfo}
            onCancel={this.toggleModal}
          />
        }
      </WelcomeContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/entrance/index.js